
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">

  
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Notifications</h4>
          </div>
          <div class="row align-items-center m-1">
            <div class="col-md-3 col-12 mb-1 mb-md-0">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-1">{{ 'MENU.DASHBOARD.SHOW' | translate }}</label>
                <select class="form-control" [(ngModel)]="basicSelectedOption">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <!-- <span class="ml-1">entries</span> -->
              </div>
            </div>
            <div class="col-md-5 col-12 mb-1 mb-md-0">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-1">{{ 'MENU.DASHBOARD.SEARCH' | translate }}</label>
                <input
                  type="search"
                  placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}"
                  class="form-control"
                  (keyup)="filterUpdate($event)"
                  (search)="filterUpdate($event)"
                />
              </div>
            </div>
            <!-- <div class="col-md-4 col-12">
              <ng-select
                [items]="selectStatus"
                [(ngModel)]="selectedStatus"
                bindLabel="name"
                placeholder="Select Status"
                (change)="filterByStatus($event)"
              ></ng-select>
            </div> -->
          </div>
  
          <ngx-datatable
            [rows]="tempData"
            [rowHeight]="78" class="bootstrap core-bootstrap bg-white"
            [limit]="basicSelectedOption" [headerHeight]="60" [footerHeight]="30"
            [scrollbarH]="true" [columnMode]="'force'" 
          >
            <ngx-datatable-column name="Id" prop="id" [width]="120">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <small
                    class="font-small-3 font-weight-bold line-height-1 mb-25"
                  >
                    {{ row.name }}
                  </small>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name="Status "
              prop="custom_client_name"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p
                    class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
                  >
                    {{ row.custom_client_name }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name="Full Name"
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
  
            <ngx-datatable-column
              name=" Age"
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name=" Email"
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name="Phone Number "
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name=" Gender"
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name=" Nationality"
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <ngx-datatable-column
              name=" Country"
              prop="custom_client_mobile"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.custom_client_mobil }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  
            <!-- New Columns -->
            <!-- <ngx-datatable-column
              name="Payment Type"
              prop="payment_type"
              [width]="80"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 line-height-1 mb-25">
                    {{ row.custom_payment_mode }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
   -->
            <!-- <ngx-datatable-column name="Total" prop="base_total" [width]="80">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 line-height-1 mb-25">
                    {{ row.currency }} {{ row.base_total }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column> -->
  
            <!-- <ngx-datatable-column name="Order Date" prop="creation" [width]="80">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 line-height-1 mb-25">
                    {{ row.creation | date : "dd-MM-yyyy" }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column> -->
  
            <!-- <ngx-datatable-column
              name="Order Status"
              prop="order_status"
              [width]="150"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p
                    class="font-medium-1 text-white font-weight-bold line-height-1 mb-25 rounded-pill"
                    style="padding: 0.5rem 0.75rem"
                    [ngClass]="getRowClass(row.custom_arbexsa_order_status)"
                  >
                    {{ row.custom_arbexsa_order_status }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column> -->
  
            <!-- <ngx-datatable-column
              name="Delivery Date"
              prop="delivery_date"
              [width]="80"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 line-height-1 mb-25">
                    {{
                      row.custom_arbexsa_order_status == "Delivered" ||
                      row.custom_arbexsa_order_status == "Returned"
                        ? (row.modified | date : "dd-MM-yyyy")
                        : "-"
                    }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column> -->
  
            <ngx-datatable-column name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}" [width]="80" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div ngbDropdown container="body">
                    <a
                      ngbDropdownToggle
                      href="javascript:void(0);"
                      class="hide-arrow"
                      id="dropdownBrowserState"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        data-feather="more-vertical"
                        class="text-primary cursor-pointer mr-50"
                      ></i>
                    </a>
                    <div
                      ngbDropdownMenu
                      class="dropdown-menu-right"
                      aria-labelledby="dropdownBrowserState"
                    >
                      <a
                        (click)="viewItems(row.name)"
                        ngbDropdownItem
                        class="d-flex align-items-center"
                        ><i data-feather="shopping-bag" class="mr-50"></i>
                        {{ 'MENU.DASHBOARD.ITEMS' | translate }}</a
                      ><a
                        (click)="viewDetails(row.name)"
                        ngbDropdownItem
                        class="d-flex align-items-center"
                        ><i data-feather="eye" class="mr-50"></i> {{ 'MENU.DASHBOARD.DETAILS' | translate }}</a
                      >
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </section>
    </div>
  </div>
  